import React, { useEffect, useState } from 'react';
import { renderVoucherStatusName, showSuccessNotification } from '../../../../../utils/render';
import ModalCloseButton from '../../CloseButton/CloseButton';
import VoucherInfo from './VoucherInfo';
import VoucherHeading from './VoucherHeading';
import Button from '../../Button/Button';
import ContentSpinner from '../../../Spinner/Spinner';
import { getTranslation } from '../../../../../utils/translation';
import { useDispatch, useSelector } from 'react-redux';
import {
    cancelVoucher,
    clearVoucher,
    getVoucher,
    reprintVoucher,
    sendVoucherReprintRequest,
} from '../../../../../store/actions/vouchers';
import { VOUCHER_STATUSES } from '../../../../../constants/enums';
import { printVoucher } from '../../../../../store/actions/betSlip';
import { setBarcodeScanned } from '../../../../../store/actions/global';

import styles from './Voucher.module.scss';

const VoucherDetailsModal = props => {
    const dispatch = useDispatch();

    const { isBarcodeScanned } = useSelector(state => state.global);
    const { cancelVoucher: cancelVoucherResponse, voucherModal } = useSelector(
        state => state.vouchers
    );
    const { voucher, loading: loadingVoucher, voucherCode, errors } = voucherModal;

    const [reprintLoading, setReprintLoading] = useState(false);
    const [isCancelDisabled, setIsCancelDisabled] = useState(false);

    useEffect(() => {
        dispatch(getVoucher(voucherCode));

        return () => {
            dispatch(setBarcodeScanned(false));
            dispatch(clearVoucher());
        };
    }, []);

    const onReprintClick = async () => {
        setReprintLoading(true);
        try {
            const hasReprintAccess = !voucher.printLimitExceeded;

            if (hasReprintAccess) {
                dispatch(reprintVoucher(voucher.code));
            } else {
                const response = await dispatch(sendVoucherReprintRequest(voucher.code));

                if (response) {
                    showSuccessNotification(
                        getTranslation('ticketInformationReprintRequestSuccess')
                    );
                }
            }
        } catch (error) {
            console.error(error);
        }
        setReprintLoading(false);
    };

    const onCancelClick = async () => {
        setIsCancelDisabled(true);

        const voucherData = await dispatch(cancelVoucher(voucher.id));

        if (voucherData) {
            await printVoucher({ ...voucherData, isCancelled: true });
        }
    };

    return (
        <>
            {loadingVoucher ? (
                <div className={styles.loading}>
                    <ContentSpinner />
                </div>
            ) : (
                voucher && (
                    <>
                        <VoucherHeading
                            statusId={voucher.status}
                            primary={renderVoucherStatusName(voucher.status)}
                        >
                            <ModalCloseButton light onClick={() => props.closeModal()} />
                        </VoucherHeading>
                        <VoucherInfo voucher={voucher} />
                        <div className={styles.actions}>
                            {voucher.status === VOUCHER_STATUSES.active ? (
                                <div className={'flex'}>
                                    <Button
                                        disabled={
                                            cancelVoucherResponse.loading ||
                                            isCancelDisabled ||
                                            !voucher.cancellationAvailability ||
                                            !isBarcodeScanned
                                        }
                                        onClick={onCancelClick}
                                        marginRight='37px'
                                        danger
                                        large
                                        title={
                                            cancelVoucherResponse.loading
                                                ? getTranslation('voucherInformationCancelLoading')
                                                : getTranslation('voucherInformationCancelButton')
                                        }
                                    />
                                    {cancelVoucherResponse.error &&
                                        cancelVoucherResponse.error.errors.map(error => (
                                            <div className={styles.actionError} key={error}>
                                                {error.reason}
                                            </div>
                                        ))}
                                </div>
                            ) : (
                                <div />
                            )}
                            <Button
                                disabled={reprintLoading}
                                onClick={onReprintClick}
                                large
                                info
                                title={
                                    voucher?.printLimitExceeded
                                        ? getTranslation('ticketInformationReprintRequestButton')
                                        : getTranslation('ticketInformationReprintButton')
                                }
                            />
                        </div>
                    </>
                )
            )}
        </>
    );
};

export default VoucherDetailsModal;
